import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { retry, catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import * as Constants from "../../constant/Constants";
@Injectable({
  providedIn: "root",
})
export class ApiCallService {
  constructor(private httpClient: HttpClient) {}

  postRequest(url: string, data: any): any {
    const filteredData = this.filterNullValues(data);

    const requestBody = JSON.stringify(filteredData);
    console.log(":: URL :: ", url);
    console.log(":: REQ :: ", requestBody);

    return fetch(url, {
      method: "POST",
      body: requestBody,
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control":
          "no-cache, no-store, must-revalidate, post-check=0, pre-check=0",
      },
    }).then((response) => response.json());
  }

  getRequest(url: string): any {
    console.log(":: URL :: ", url);

    return fetch(url, {
      method: "GET",
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control":
          "no-cache, no-store, must-revalidate, post-check=0, pre-check=0",
      },
    }).then((response) => response.json());
  }

  filterNullValues<T extends { [key: string]: any }>(obj: T): Partial<T> {
    return Object.keys(obj)
      .filter((key: keyof T) => obj[key] !== null)
      .reduce((filteredObj: Partial<T>, key: keyof T) => {
        filteredObj[key] = obj[key];
        return filteredObj;
      }, {});
  }

  sspLogin({
    body,
    token,
  }: {
    body: { username: string; password: string };
    token: string;
  }): Observable<any> {
    const url = environment.baseUrl.replace("motor", "life") + "/auth";
    return this.httpClient.post<any>(url, body, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: token,
      }),
    });
  }
  submitSsp({ res, token }: { res: any; token: string }): Observable<any> {
    const url = environment.baseUrl.replace("motor", "life") + "/submitSsp";
    return this.httpClient.post<any>(url, res, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        token: token,
      }),
    });
  }
}
